import * as Yup from 'yup';
// Import Constants
import { TemplateTypesLabels, l } from 'constants/common';
import { EMAIL_VALIDATION_REGEXP } from 'constants/regexp';

const DropDownRequestTypes = {
    GET: 'GET',
};

const TestSendToInputElementsConfig = {
    [TemplateTypesLabels.Internal]: {
        placeholder: l.InputClientId,
        fieldName: 'Id',
        initialValues: {
            Id: '',
        },
        validationSchema: (t) =>
            Yup.object({
                Id: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.InputClientId) })),
            }),
    },
    [TemplateTypesLabels.Email]: {
        placeholder: l.EmailAddress,
        fieldName: 'Email',
        initialValues: {
            Email: '',
        },
        validationSchema: (t) =>
            Yup.object({
                Email: Yup.string()
                    .required(t(l.CannotBeEmpty, { fieldName: t(l.EmailAddress) }))
                    .matches(EMAIL_VALIDATION_REGEXP, t(l.EmailIsNotInCorrectFormat)),
            }),
    },
    [TemplateTypesLabels.Telegram]: {
        placeholder: l.TelegramChatId,
        fieldName: 'TelegramChatId',
        initialValues: {
            TelegramChatId: '',
        },
        validationSchema: (t) =>
            Yup.object({
                TelegramChatId: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.TelegramChatId) })),
            }),
    },
    [TemplateTypesLabels.SMS]: {
        placeholder: l.PhoneNumber,
        fieldName: 'MobilePhone',
        initialValues: {
            MobilePhone: '',
        },
        validationSchema: (t) =>
            Yup.object({
                MobilePhone: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.PhoneNumber) })),
            }),
    },
    [TemplateTypesLabels.PushNotification]: {
        placeholder: l.InputClientId,
        fieldName: 'Id',
        initialValues: {
            Id: '',
        },
        validationSchema: (t) =>
            Yup.object({
                Id: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.InputClientId) })),
            }),
    },
    [TemplateTypesLabels.Hoory]: {
        placeholder: l.InputClientId,
        fieldName: 'Id',
        initialValues: {
            Id: '',
        },
        validationSchema: (t) =>
            Yup.object({
                Id: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.InputClientId) })),
            }),
    },
    [TemplateTypesLabels.Viber]: {
        placeholder: l.PhoneNumber,
        fieldName: 'PhoneNumber',
        initialValues: {
            PhoneNumber: '',
        },
        validationSchema: (t) =>
            Yup.object({
                PhoneNumber: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.PhoneNumber) })),
            }),
    },
    [TemplateTypesLabels.WhatsApp]: {
        placeholder: l.PhoneNumber,
        fieldName: 'PhoneNumber',
        initialValues: {
            PhoneNumber: '',
        },
        validationSchema: (t) =>
            Yup.object({
                PhoneNumber: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.PhoneNumber) })),
            }),
    },
    [TemplateTypesLabels.WhatsAppProvider]: {
        placeholder: l.PhoneNumber,
        fieldName: 'PhoneNumber',
        initialValues: {
            PhoneNumber: '',
        },
        validationSchema: (t) =>
            Yup.object({
                PhoneNumber: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.PhoneNumber) })),
            }),
    },
    [TemplateTypesLabels.DynamicPopUp]: {
        placeholder: l.InputClientId,
        fieldName: 'Id',
        initialValues: {
            Id: '',
        },
        validationSchema: (t) =>
            Yup.object({
                Id: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.InputClientId) })),
            }),
    },
    [TemplateTypesLabels.CMSBanner]: {
        placeholder: l.InputClientId,
        fieldName: 'Id',
        initialValues: {
            Id: '',
        },
        validationSchema: (t) =>
            Yup.object({
                Id: Yup.string().required(t(l.CannotBeEmpty, { fieldName: t(l.InputClientId) })),
            }),
    },
};

export { DropDownRequestTypes, TestSendToInputElementsConfig };
